import DockyardForm from "$containers/Dockyard/DockyardForm";
import useDockyardForm from "$hooks/useDockyardForm";

export const PopinDockyard = ({ togglePopin }: any) => {
  const {
    handleSubmit: handleSubmitDockyard,
    error: errorDockyard,
    submitting: submittingDockyard,
  } = useDockyardForm(undefined, togglePopin);

  return (
    <DockyardForm
      error={errorDockyard}
      onSubmit={handleSubmitDockyard}
      onCancel={togglePopin}
      isSubmitting={submittingDockyard}
    />
  );
};
